export default __webpack_public_path__ + "static/media/logo.20bbe770.png";